import { Grid } from "@mui/material";
import {
    EmailFieldRHF,
    EnhancedCheckboxRHF,
    EnhancedDropDownRHF,
    EnhancedDropDownRHFWithLabel,
    EnhancedTextAreaFieldRHF,
    LabelPosition,
    RHookFormPasswordFieldWithLabel,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface INotesInfoFieldsPanel {
}
export const NotesInfoFieldsPanel: FC<
    INotesInfoFieldsPanel
> = ({ }) => {

    return (
        <>
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} >
                <EnhancedDropDownRHF
                    selectName="savefor"
                    testId="Save-for"
                    items={[
                        { label: "Save for each pay period", value: 200 },
                        { label: "Save for each employee", value: 100 },
                    ]}
                    selectedItem={200}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} >
                <EnhancedTextAreaFieldRHF
                    label=""
                    id="notes"
                    testId={`notes`}
                    labelPosition={LabelPosition.Top}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }} >
                <EnhancedCheckboxRHF
                    name="printOnStub"
                    checked={false}
                    testId="print-on-stub"
                    checkboxLabel="Print on Stub"
                />
            </Grid>
        </>
    );
};
